import { LOGIN, LOGOUT } from "../types";

const initialState = {
  user: null,
  uid: null,
};

export default function authUserReducer(
  state = initialState,
  { type, payload }
) {
  switch (type) {
    case LOGIN:
      return {
        ...state,
        user: payload.user,
        uid: payload.uid,
      };
    case LOGOUT:
      localStorage.clear();
      return {
        ...state,
        user: null,
        uid: null,
      };

    default:
      return { ...state };
  }
}
